import { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Button from '../../../common/Button'
import InputText from '../../../common/InputText'
import { postRequest } from '../../../../services/base'
import { NavContext } from '../../../../context/global_context'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'

const DEFAULT_FORM_VALUES = {
  name: '',
  vin_identifier: '',
  time_zone: '',
  location: '',
  make: '',
}

const PlantEditCreateForm = (props) => {
  const [state, dispatch] = useContext(NavContext)

  const [plantDetails, setPlantDetails] = useState(DEFAULT_FORM_VALUES)

  useEffect(() => {
    if (props?.selectedPlant?.id) {
      setPlantDetails(props?.selectedPlant)
    } else {
      setPlantDetails(DEFAULT_FORM_VALUES)
    }
  }, [props?.selectedPlant?.id])

  const savePlantDetails = async (e) => {
    const form = e.target
    const formData = new FormData(form)
    let res = await postRequest(`/api/plants/save_plants/`, formData)
    if (Object.keys(res?.errors).length > 0) {
      let msg = ''
      Object.keys(res?.errors).map((obj) => {
        if (msg) {
          msg += `, ${res.errors[obj]}`
        } else {
          msg = `${res.errors[obj]}`
        }
      })

      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: msg,
        },
      })
    } else if (res?.msg) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      setPlantDetails({})
      props.onSave()
    }
  }

  return (
    <Modal
      onClose={() => {
        setPlantDetails({})
        props.setShowModal(false)
      }}
      show={props.showModal}
    >
      <ModalHeader className={'text-white'}>
        {props.selectedPlant?.id ? 'Update Existing Plant' : 'Create New Plant'}
      </ModalHeader>
      <ModalBody>
        <div className="">
          <form
            onSubmit={(e) => {
              e.preventDefault()
              savePlantDetails(e)
            }}
          >
            <input
              type="hidden"
              value={props?.selectedPlant?.id ? false : true}
              name="is_create"
            />
            {props?.selectedPlant?.id && (
              <input type="hidden" name="id" value={props?.selectedPlant?.id} />
            )}
            <div className="flex">
              <div className="w-1/2">
                <InputText
                  name="name"
                  type="text"
                  label="Name"
                  value={plantDetails.name}
                />
              </div>
              <div className="w-1/2">
                <InputText
                  name="vin_identifier"
                  type="text"
                  label="Vin Identifier"
                  value={plantDetails.vin_identifier}
                  onChange={(value) => {
                    setPlantDetails({ ...plantDetails, vin_identifier: value })
                  }}
                  isRequired={false}
                />
              </div>
            </div>
            <div className="flex">
              <div className="w-1/2">
                <InputText
                  name="time_zone"
                  type="text"
                  label="Time Zone"
                  value={plantDetails.time_zone}
                  onChange={(value) => {
                    setPlantDetails({ ...plantDetails, time_zone: value })
                  }}
                />
              </div>
              <div className="w-1/2">
                <InputText
                  name="location"
                  type="text"
                  label="Location"
                  value={plantDetails.location}
                  onChange={(value) => {
                    setPlantDetails({ ...plantDetails, location: value })
                  }}
                />
              </div>
            </div>
            <div className="flex">
              <div className="w-1/2">
                <InputText
                  name="make"
                  type="text"
                  label="Make Details"
                  value={plantDetails.make}
                  onChange={(value) => {
                    setPlantDetails({ ...plantDetails, make: value })
                  }}
                />
              </div>
            </div>

            <div className="flex justify-end">
              <div className="w-1/4">
                <Button
                  type="submit"
                  className={`cursor-pointer btn my-4 w-full justify-end`}
                  onClick={(e) => {}}
                  value={'text'}
                  text={
                    props.selectedPlant?.id ? 'Save Plant' : 'Create New Plant'
                  }
                />
              </div>
            </div>
          </form>
        </div>
      </ModalBody>
    </Modal>
  )
}

PlantEditCreateForm.propTypes = {
  selectedPlant: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  setShowModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
}

export default PlantEditCreateForm
